const Horn = Mach.requireModule('SLCHorn');

/**
 * 获取地图是否开始 isSetHongKongBounds 配置
 * true: 限制香港区域
 * false: 不限制区域
 * @returns {boolean}
 */
function isSetHongKongBounds() {
  const hornConfig = Horn?.getAppConfig?.();
  let isLimit = true;
  if (hornConfig) {
    isLimit = hornConfig.isSetHongKongBounds ?? true;
  }
  return isLimit;
}

/**
 * 获取前置收银台降级开关配置
 * @returns {boolean}
 */
function getPaymentRollback() {
  const config = Horn?.getAppConfig?.();
  return config?.payment_rollback ?? false;
}

export { isSetHongKongBounds, getPaymentRollback };
